import { registerSystemInfoTab } from "routes/sfg20-admin/plugins/system-info/register-system-info-tab"
import { Reports } from "routes/sfg20-admin/plugins/system-info/reports-tab/reports"

registerSystemInfoTab("Reports", <Reports $lazy />, 3)
